import React from "react";
import {useSelector} from "react-redux";
import { RootState } from "../../store/store";
import { FileText, Image, Search, Tag, Tags, FolderTree, ShoppingCart } from "lucide-react";
import MetricsCard from "../../components/ui/MetricsCard";
import { useTranslation } from "../../i18n/hooks";

const MetricsView = () => {
    const { t } = useTranslation();
    const {
      titleQualityScore,
      dashboardTitleQualityMessage,
      descriptionQualityScore,
      dasboardDescriptionQualityMessage,
      imageQualityScore,
      dashboardImageQualityMessage,
      seoQualityScore,
      dashboardSeoQualityMessage,
      altTagsQualityScore,
      dashboardAltTagsQualityMessage,
      categoryQualityScore,
      dashboardCategoryQualityMessage,
      tagsScore,
      dashboardProductTagsQualityMessage,
    } = useSelector((state: RootState) => state.score);
    const metrics = [
      {
        title: t('dashboard.titles'),
        score: titleQualityScore,
        icon: FileText,
        enrichmentFeatures: ["title"],
        category: "conversion",
        suggestion: t('dashboard.suggestion_titles'),
        description: dashboardTitleQualityMessage,
      },
      {
        title: t('dashboard.descriptions'),
        score: descriptionQualityScore,
        icon: FileText,
        category: "conversion",
        enrichmentFeatures: ["description"],
        suggestion: t('dashboard.suggestion_descriptions'),
        description: dasboardDescriptionQualityMessage,
      },
      {
        title: t('dashboard.images'),
        score: imageQualityScore,
        icon: Image,
        enrichmentFeatures: ["image_finder"],
        suggestion: t('dashboard.suggestion_images'),
        category: "conversion",
        description: dashboardImageQualityMessage,
      },
      {
        title: t('dashboard.seo'),
        score: seoQualityScore,
        icon: Search,
        suggestion: t('dashboard.suggestion_seo'),
        enrichmentFeatures: ["seo"],
        category: "search",
        description: dashboardSeoQualityMessage,
      },
      {
        title: t('dashboard.alt_texts'),
        score: altTagsQualityScore,
        icon: Tag,
        suggestion: t('dashboard.suggestion_alt_texts'),
        enrichmentFeatures: ["altText"],
        category: "search",
        description: dashboardAltTagsQualityMessage,
      },
      {
        title: t('dashboard.categories'),
        score: categoryQualityScore,
        icon: FolderTree,
        suggestion: t('dashboard.suggestion_categories'),
        enrichmentFeatures: ["categoryPlacement"],
        category: "findability",
        description: dashboardCategoryQualityMessage,
        isUpcoming: true, // Added this field
      },
      {
        title: t('dashboard.tags'),
        score: tagsScore,
        icon: Tags,
        suggestion: t('dashboard.suggestion_tags'),
        enrichmentFeatures: ["productTags"],
        category: "findability",
        description: dashboardProductTagsQualityMessage,
      },
    ];
    return (
      <>
      <MetricsCard
        title={t('dashboard.conversion_drivers')}
        icon={ShoppingCart}
        iconColor="text-red-500"
        category="conversion"
        metrics={metrics}
      />
  
      <MetricsCard
        title={t('dashboard.findability_features')}
        icon={ShoppingCart}
        iconColor="text-red-500"
        category="findability"
        metrics={metrics}
      />
  
      <MetricsCard
        title={t('dashboard.search_performance')}
        icon={ShoppingCart}
        iconColor="text-red-500"
        category="search"
        metrics={metrics}
      />
      </>
    )
  }
  

  export default MetricsView;